"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceQualificationClientFactory = void 0;
const client_1 = require("./client/client");
const formatter_1 = require("./formatter/formatter");
const axiosHttpClient_1 = require("./http/axiosHttpClient");
const serviceQualificationClient_1 = require("./serviceQualificationClient");
class ServiceQualificationClientFactory {
    static create(baseUrl) {
        // Do dependency management manually as this is a small project.
        return new serviceQualificationClient_1.ServiceQualificationClient(new client_1.Client(new axiosHttpClient_1.AxiosHttpClient(baseUrl)), new formatter_1.Formatter());
    }
}
exports.ServiceQualificationClientFactory = ServiceQualificationClientFactory;
//# sourceMappingURL=serviceQualificationClientFactory.js.map